$(document).ready(function () {
	$(".btn-load-catalog").click(function () {
		var route = $(this).attr('href');

		$(this).closest('ul').find('.btn-load-catalog').removeClass('active');
		$(this).addClass('active');

		$('.btn-load-more-catalog').attr('data-route', $(this).data('load-more-route'));

		$.get(route, {}, function (data) {
			if (data.view) {
				$("#catalog-photos").html(data.view);

				$('#catalog-photos .btn-load-more-catalog').each(function () {
					$(this).vegasLoadMore({
						limit: 8,
						offset: 8,
						onLoad: function ($self, data) {
							let target = $self.attr('data-target'),
								obj = data;

							if (obj.view.length) {
								$(target).append(obj.view);
							}

							if (data.cntPhotos <= 8) {
								$self.fadeOut();
							}
						},
						onClick: function ($self) {
							$self.text('Загружаю...')
						}
					})
				});
			}
		});

		return false;
	});

	$(".btn-load-catalog").first().trigger('click');
});